import { useTranslation } from "react-i18next";
import classes from "./PromoCard.module.css";

import { PromoCardItem } from "./PromoCardItem";

export const PromoCard = () => {
	const { t, i18n } = useTranslation();
	const items = [
		{
			title: t("navigation.menuList.svod"),
			buttonText: t("promo.tvodButtonText"),
			buttonLink: "/subscription",
			description: i18n?.language.includes("fi")
				? ` <br/><h2>9,99 &euro;/kk</h2><br/>

			<h2>Elokuvat ja sarjat</h2>
			<br/>

			<p>Jatkuvasti kasvava valikoima huippuelokuvia ja -sarjoja.</p>
      <br/><p>Ei pitkää sitoutumista, keskeytä koska tahansa.</p>`
				: `<br/><h2>9.99 euros/month</h2><br/>

			<h2>Movies and series</h2>
			<br/>

			<p>A constantly growing selection of top movies and series.</p>

      <br/>
      <p>No long commitment, cancel anytime.</p>`,

			content: (
				<>
					<h1
						style={{
							marginBottom: "12px",
							marginTop: "12px",
							fontSize: "2.4em",
						}}
					>
						9,99 €/kk
					</h1>
					<h3
						style={{
							marginBottom: "5px",
							fontSize: "1.4em",
						}}
					>
						{i18n?.language.includes("fi") ? "Elokuvat ja sarjat" : "Movies and series"}
					</h3>

					<p
						style={{
							color: "rgba(210,198,198)",
							display: "flex",
							flexDirection: "column",
							gap: "12px",
							fontSize: "16px",
						}}
					>
						<p style={{}}>
							{i18n?.language.includes("fi")
								? "Jatkuvasti kasvava valikoima huippuelokuvia ja -sarjoja."
								: "A constantly growing selection of top movies and series."}
						</p>
						<p>
							{i18n?.language.includes("fi")
								? "Ei pitkää sitoutumista, keskeytä koska tahansa."
								: "No long commitment, cancel anytime."}
						</p>
					</p>
				</>
			),
		},
		{
			title: t("navigation.menuList.tvod"),
			description: i18n?.language.includes("fi")
				? `<h2><br />
			Elokuvat ja sarjat</h2>

			<p>Vuokraa elokuvia ja sarjoja kertamaksulla. Vuokraelokuva on katsottavissa 48h ajan.</p>

			<h2 style=margin-bottom:5px><br /><strong>
			Aina edulliset hinnat </strong></h2>

			<p>Alk. 3,99 &euro;<br />
			&nbsp;</p>`
				: `<h2><br />
			Movies and series</h2>

			<p>Rent movies and series for a one-time fee. The rental movie can be watched for 48 hours.</p>

			<h2 style="margin-bottom:5px"><br /><strong>
			Always affordable prices </strong></h2>

			<p>Starting from 3.99 euros<br />
			&nbsp;</p>
			`,

			buttonText: t("promo.tvodButtonText"),

			buttonLink: "/vuokraamo",

			content: (
				<>
					<h3
						style={{
							marginBottom: "5px",
							fontSize: "1.4em",
							marginTop: "30px",
						}}
					>
						{i18n?.language.includes("fi") ? "Elokuvat ja sarjat" : "Movies and series"}
					</h3>

					<p
						style={{
							color: "rgba(210,198,198)",
							fontSize: "16px",
						}}
					>
						<p style={{}}>
							{i18n?.language.includes("fi")
								? "Vuokraa elokuvia ja sarjoja kertamaksulla. Vuokraelokuva on katsottavissa 48h ajan."
								: "Rent movies and series for a one-time fee. The rental movie can be watched for 48 hours."}
						</p>
					</p>
					<h3
						style={{
							marginBottom: "5px",
							fontSize: "1.4em",
							marginTop: "20px",
						}}
					>
						{i18n?.language.includes("fi") ? "Aina edulliset hinnat" : "Always affordable prices"}
					</h3>

					<p
						style={{
							color: "rgba(210,198,198)",
							fontSize: "16px",
						}}
					>
						{i18n?.language.includes("fi") ? "Alk. 3,99 €" : "Starting from 3.99 €"}
					</p>
				</>
			),
		},
	];
	return (
		<div className={classes.container}>
			{items.map((el) => (
				<PromoCardItem item={el} key={el.title} />
			))}
		</div>
	);
};

// import { useTranslation } from "react-i18next";
// import { KotikinoChristmasOffer, PromoCardItem } from "./PromoCardItem";

// export const PromoCard = () => {
// 	const { t } = useTranslation();

// 	const items = [
// 		{
// 			title: "KOTIKINON JOULUTARJOUS",
// 			buttonText: t("promo.tvodButtonText"),
// 			buttonLink: "/subscriptions",
// 			content: (
// 				<>
// 					<p
// 						style={{
// 							margin: 0,
// 							marginBottom: "8px",
// 							fontSize: "1em",
// 							color: "rgba(255,255,255,0.9)",
// 						}}
// 					>
// 						Ensimmäinen kuukausi
// 					</p>

// 					<h2
// 						style={{
// 							margin: 0,
// 							marginBottom: "12px",
// 							fontSize: "3.2em",
// 							fontWeight: 700,
// 							lineHeight: 1,
// 							color: "#ffffff",
// 						}}
// 					>
// 						vain <span style={{ color: "#ff4d6d" }}>1 €</span>
// 						<span
// 							style={{
// 								fontSize: "0.45em",
// 								fontWeight: 500,
// 								marginLeft: "6px",
// 							}}
// 						>
// 							/kk
// 						</span>
// 					</h2>

// 					<p
// 						style={{
// 							margin: 0,
// 							fontSize: "14px",
// 							color: "rgba(255,255,255,0.75)",
// 						}}
// 					>
// 						Tarjous voimassa 31.12.2025 asti
// 					</p>

// 					<p
// 						style={{
// 							margin: 0,
// 							marginTop: "4px",
// 							fontSize: "13px",
// 							color: "rgba(255,255,255,0.6)",
// 						}}
// 					>
// 						normaalihinta 9,99 €/kk
// 					</p>
// 				</>
// 			),
// 		},
// 	];

// 	return (
// 		<div
// 			style={{
// 				display: "grid",
// 				gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
// 				gap: "16px",
// 			}}
// 		>
// 			{items.map((el) => (
// 				<KotikinoChristmasOffer />
// 			))}
// 		</div>
// 	);
// };
